import TaskRow from "./TaskRow";
import type { Task, TaskStatus } from "@/lib/types";
import { panelClass } from "@/components/ui/modal-panel";

interface Props {
  tasks: Task[];

  projectById: Map<string, any>;
  getCreatorLabel: (t: Task) => string;

  onStatus: (t: Task, s: TaskStatus) => void;
  onPin: (id: string) => void;
  onEdit: (t: Task) => void;
  onDelete: (t: Task) => void;
  onShare?: (t: Task) => void;

  getStatusBadge: (s: TaskStatus) => string;
  getStatusLabel: (s: TaskStatus) => string;
  pinnedIds: Set<string>;
  onRowClick?: (t: Task) => void;
}

export default function TaskGrid({
  tasks,
  projectById,
  getCreatorLabel,
  onStatus,
  onPin,
  onEdit,
  onDelete,
  onShare,
  getStatusBadge,
  getStatusLabel,
  pinnedIds,
  onRowClick,
}: Props) {
  return (
    <div className={`rounded-xl ${panelClass} bg-black/60 overflow-auto`}>
      <table className="w-full text-xs border-collapse">

        {/* HEADER */}
        <thead className="text-m p-0.5 bg-purple-700/40 ring-1 ring-[#7b2ee6]/60">
          <tr>

            {/* Tasks left aligned */}
            <th className="px-3 py-2 text-left text-[16px] text-purple-100 w-[200px]">Tasks</th>

            {/* centered headers */}
            <th className="px-3 py-2 text-center text-[16px] text-purple-100 w-[250px]">Project</th>
            <th className="px-3 py-2 text-center text-[16px] text-purple-100 w-[130px]">Assignee</th>
            <th className="px-3 py-2 text-center text-[16px] text-purple-100 w-[150px]">Due Date</th>
            <th className="px-3 py-2 text-center text-[16px] text-purple-100 w-[140px]">Timeline</th>
            <th className="px-3 py-2 text-center text-[16px] text-purple-100 w-[140px]">Status</th>
            <th className="px-3 py-2 text-center text-[16px] text-purple-100 w-[130px]">Manage</th>
          </tr>
        </thead>

        <tbody>
          {tasks.map((t) => {
            const meta = t.project_id ? projectById.get(t.project_id) : null;

            return (
              <TaskRow
                key={t.id}
                task={t}
                projectMeta={meta}
                creator={getCreatorLabel(t)}
                isPinned={pinnedIds.has(t.id)}
                onStatus={onStatus}
                onPin={onPin}
                onEdit={onEdit}
                onDelete={onDelete}
                onShare={onShare}
                getStatusBadge={getStatusBadge}
                getStatusLabel={getStatusLabel}
                onRowClick={onRowClick}
              />
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
